module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin/profile"
    }
  }, [_c('span', [_vm._v("Profile")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logOutAdmin.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("Logout")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": "/static/img/pro1.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5147424a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/UserMenu.vue
// module id = 2091
// module chunks = 1